import React, { useState } from 'react'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'

function ActivityBoxInvitations({ activityCount, activityText, className, handleResendAll }) {
  const { t } = useTranslation()
  return (
    <div className={`${styles.invitationActivity} ${className}`}>
      <div className={styles.contentBox}>
        <div className={styles.number}>{activityCount}</div>

        <div className={styles.mainContent}>
          <div className={styles.text}>{activityText}</div>
          {activityCount > 0 && (
            <Button
              text={t('dashboard.renewAllInvites')}
              style='transparent'
              className='button is-tertiary is-orange-dark'
              handleClick={handleResendAll}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ActivityBoxInvitations
